import { defineMessages } from 'react-intl-next';

export default defineMessages({
	closeButtonLabel: {
		id: 'ai-mate.inline-chat-input.error-view.close-button.label',
		defaultMessage: 'Close',
		description: 'Label for the close button in the error state of a status indicator',
	},
	retryButtonLabel: {
		id: 'ai-mate.inline-chat-input.error-view.retry-button.label',
		defaultMessage: 'Try again',
		description: 'Label for the retry button in the error state of a status indicator',
	},
});
